<template>
  <v-tooltip :value="value" :disabled="tooltipDisabled" :color="tooltipColor" v-bind="attrs">
    <template v-slot:activator="{ on }">
      <span v-on="on" :class="containerClass">
        <slot v-on="on"></slot>
      </span>
    </template>
    <slot name="tooltip" class="app-tooltip-content"></slot>
  </v-tooltip>
</template>

<script>
import intersection from 'lodash/intersection';
import merge from 'lodash/merge';

export default {
  name: 'AppTooltip',
  inheritAttrs: false,
  inject: ['isMobile'],
  data: function() {
    return {
      attrs: {
        'open-delay': this.isMobile ? '0' : '500',
        transition: 'scale-transition',
        'content-class': ''
      }
    };
  },
  props: ['color', 'containerClass', 'value', 'disabled'],
  computed: {
    tooltipColor() {
      return this.color || 'primary';
    },
    tooltipDisabled() {
      return typeof this.disabled !== 'undefined'
        ? this.disabled
        : this.isMobile;
    }
  },
  created() {
    let keys = intersection(
      ['top', 'left', 'bottom', 'right'],
      Object.keys(this.$attrs)
    );
    if (!keys.length) {
      this.attrs.bottom = true;
    }
    this.attrs = merge(this.attrs, this.$attrs);
    this.attrs['content-class'] += ' app-tooltip-content';
  }
};
</script>

<style lang="scss" scoped>
.app-tooltip-content {
  font-size: 0.9rem;
  max-width: 75vw;
  white-space: normal;
  overflow: hidden;
  overflow-wrap: break-word;
}
</style>
